import React from "react";
import { CallToActionButton } from "./callToActionButton";

interface FundraiserSectionProps {
  fundraiserSectionRef: React.RefObject<HTMLDivElement>;
  headingRef: React.RefObject<HTMLParagraphElement>;
  textRef: React.RefObject<HTMLDivElement>;
  buttonRef: React.RefObject<HTMLDivElement>;
  illustrationRef: React.RefObject<HTMLImageElement>;
}

export const FundraiserSection: React.FC<FundraiserSectionProps> = ({
  fundraiserSectionRef,
  headingRef,
  textRef,
  buttonRef,
  illustrationRef,
}) => {
  return (
    <div
      ref={fundraiserSectionRef}
      className="flex h-auto flex-col bg-[#FFF3ED] lg:h-[824px] lg:flex-row"
    >
      <div className="order-2 mx-[16px] mb-[24px] mt-[32px] flex flex-col gap-[32px] md:mx-[32px] lg:order-none lg:mx-[75px] lg:mb-[48px] lg:mt-[202.5px] lg:w-[649px]">
        <p
          ref={headingRef}
          className="font-inter text-[42px] font-medium leading-[100%] tracking-[-0.03em] text-[#131313] lg:font-dm-sans lg:text-[64px] lg:tracking-[-0.02em]"
        >
          <span className="mr-[0.25em] inline-block">Fuel</span>
          <span className="mr-[0.25em] inline-block">for</span>
          <span className="mr-[0.25em] inline-block">Your</span>
          <span className="mr-[0.25em] inline-block">Fundraising</span>
          <span className="inline-block">Efforts</span>
        </p>
        <div ref={textRef}>
          <p className="font-inter text-[16px] font-normal leading-[140%] tracking-[0%] text-[#5A5A59] lg:text-[18px] lg:text-[#131313]">
            Fuel your fundraising efforts with the knowledge you need to take
            your fundraiser to the next level?
          </p>
          <p className="mt-4 font-inter text-[16px] font-normal leading-[140%] tracking-[0%] text-[#5A5A59] lg:text-[18px] lg:text-[#131313]">
            Get proven strategies, success stories, and essential tips to help
            you maximize donations and engage supporters.
          </p>
        </div>
        <div ref={buttonRef}>
          <CallToActionButton
            className="max-w-[187px]"
            isTransparent={false}
            title="Start Here"
          />
        </div>
      </div>

      <div className="order-1 mb-[48px] mt-[56.88px] flex w-full flex-col md:px-[32px] lg:order-none lg:mx-[75px] lg:mt-[120px] lg:flex-1">
        <img
          ref={illustrationRef}
          src="/assets/images/blog-illustration.svg"
          alt="blog-illustration"
          className="w-full px-[16px] md:px-0 lg:max-w-[649px]"
        />
      </div>
    </div>
  );
};
